<template>
  <md-card class="m-0">
    <md-card-header>
      <div class="row">
        <div class="col-6">
          <div class="md-title">Ultimas Notificações</div>
        </div>
        <div class="col-5" style="text-align: right">
          <router-link
            v-if="isAdmin"
            :to="{ name: 'NotificacaoLogIndex', params: { localId: localId } }"
          >
            <md-button class="md-primary md-raised"> acompanhar </md-button>
          </router-link>
        </div>
      </div>
    </md-card-header>
    <md-card-content>
      <md-table>
        <md-table-row>
          <md-table-head>Titulo</md-table-head>
          <md-table-head>Mensagem</md-table-head>
          <md-table-head>Horário</md-table-head>
        </md-table-row>
        <md-table-row v-for="notificacao in notificacoes" :key="notificacao.id">
          <md-table-cell>
            <p>
              {{ notificacao.titulo }}
            </p>
          </md-table-cell>
          <md-table-cell>{{ notificacao.mensagem }}</md-table-cell>
          <md-table-cell>
            <div class="row">
              <div class="col">
                {{ formatDate(notificacao.horarioEnvio) }}
              </div>

              <div class="col-3">
                <md-icon
                  class="md-primary"
                  :style="{
                    ['color']: getNotificationIconColor(
                      notificacao.nivelNotificacao
                    ),
                    ['border-radius']: '2px',
                    ['min-height']: '2vh',
                    ['min-width']: '2vh',
                  }"
                >
                  {{ getNotificationIconName(notificacao.nivelNotificacao) }}
                </md-icon>
                <md-tooltip md-direction="left">
                  {{ getNotificationIconTooltip(notificacao.nivelNotificacao) }}
                </md-tooltip>
              </div>
            </div>
          </md-table-cell>
        </md-table-row>
      </md-table>
    </md-card-content>
  </md-card>
</template>

<script>
import auth from '@/utils/auth'
import http from '@/utils/http'
import {
  formatDate,
  getNotificationIconColor,
  getNotificationIconName,
  getNotificationIconTooltip,
} from '@/utils/transform'

export default {
  name: 'UltimasNotificacoesIndex',
  props: {
    localId: {
      type: String,
      default: '',
    },
    limit: {
      type: Number,
      default: 20,
    },
  },
  data() {
    return {
      notificacoes: [],
    }
  },
  computed: {
    isAdmin: auth.isAdmin,
  },
  async beforeMount() {
    this.notificacoes = (
      await http.get(`local/${this.localId}/notificacoes/historico`, {
        pageSize: this.limit,
      })
    ).historico.results
  },
  methods: {
    formatDate,
    getNotificationIconColor,
    getNotificationIconName,
    getNotificationIconTooltip,
  },
}
</script>

<style scoped lang="scss">
.md-table-row-custom-hover:hover {
  cursor: pointer;
}
</style>
